// extracted by mini-css-extract-plugin
export default {"main":"ModalCrearCentroEstudios_main__B-lQq","intro":"ModalCrearCentroEstudios_intro__J3oo6","input":"ModalCrearCentroEstudios_input__XTksY"};